namespace TabAurous {
    @Serenity.Decorators.registerEditor()
    export class InlineLookupEditor extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, any>  {

        lookupKey: string;

        constructor(container: JQuery, options?: Serenity.LookupEditorOptions) {
            super(container, options);
            this.lookupKey = options.lookupKey;
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var customLookup = Q.getLookup(this.options.lookupKey);
            let items: any = super.getItems(customLookup);
            return items;
        }

        protected getSelect2Options(): Select2Options {
            var opt = super.getSelect2Options();
            opt.dropdownAutoWidth = true;
            return opt;
        }
    }
}